/** @flow */

import { all, put, takeEvery, call, takeLatest } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import config from "@config";
import { ExportSimpleList, ExportSimpleListSuccess } from "@modules/hierarchy/constants/actions";
import actionCreators from "@modules/hierarchy/actionCreator";
import { downloadCsvFile } from "@sagas/utils";

type ExportSimpleListRequest = $Exact<{
  clientId: string,
  page?: number,
}>;

export function* onExportSimpleList({
  payload,
}: Action<ExportSimpleListRequest>): Generator<*, void, Object> {
  if (!payload || !payload.clientId) {
    throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
  }

  try {
    const result = yield call(
      http.get,
      `${config.endpointBaseUrl}api/v1/hierarchy-admin/client/${payload.clientId}/hierarchy/detailed/export`,
    );

    yield put(actionCreators.ExportSimpleListSuccess(result.data || ""));
  } catch (e) {
    yield put(actionCreators.ExportSimpleListError(e.response));
  }
}

export function* onExportSimpleListSuccess({ payload }: Action<any>): Generator<*, void, any> {
  yield downloadCsvFile(payload, "current-hierarchy.csv");
}

export function* HierarchyChangesSagas(): Generator<*, void, void> {
  yield all([
    takeEvery(ExportSimpleList, onExportSimpleList),
    takeLatest(ExportSimpleListSuccess, onExportSimpleListSuccess),
  ]);
}

export default HierarchyChangesSagas;
